import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {
  fetchBodyMeasurements,
  fetchWeightGraph,
} from '/redux/action/client.action';
import {
  bodyMeasurementsData,
  weightGraphData,
} from '/redux/selector/client.selector';
import {fromProps, withProps} from '/util/selector.util';

import HealthProfile from './HealthProfile';
interface MWLData {
  data: {
    weightProgress?: string;
    measurementProgress?: string;
  };
}
const withClientId = withProps({
  clientId: fromProps(get('recordId')),
});

const mapStateToProps = createStructuredSelector({
  weightGraphData: withClientId(weightGraphData),
  bodyMeasurementsData: withClientId(bodyMeasurementsData),
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchWeightGraph: ({clientId}: any) => dispatch(fetchWeightGraph({clientId})),
  fetchBodyMeasurements: ({clientId}: any) =>
    dispatch(fetchBodyMeasurements({clientId})),
});
const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,

  fetchWeightGraph: async (mwldata: MWLData, clientId: string) => {
    const {weightProgress} = mwldata.data || {};

    await Promise.resolve().then(() =>
      weightProgress
        ? dispatchProps.fetchWeightGraph({clientId})
        : Promise.resolve(),
    );
  },
  fetchBodyMeasurements: async (mwldata: MWLData, clientId: string) => {
    const {measurementProgress} = mwldata.data || {};
    await Promise.resolve().then(() =>
      measurementProgress
        ? dispatchProps.fetchBodyMeasurements({clientId})
        : Promise.resolve(),
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(HealthProfile);
